import { GridColumnType } from "../../../data/gridColumnType";

export const SGBPCategoryCriteriaConfig = {
  columns: [
    {
      name: "Category (L1)",
      fieldName: "categoryL1Name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Sub Category (L2)",
      fieldName: "subCategoryL2Name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Type (L3)",
      fieldName: "typeL3Name",
      colType: GridColumnType.Text,
    },
    {
      name: "Code",
      fieldName: "code",
      colType: GridColumnType.Text,
    },
    {
      name: "Certificate",
      fieldName: "certificate",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "statusName",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "Edit",
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
